import React, { Component } from 'react'

export default class LoadMoreNextWeek extends Component {
    render() {
        return <button type="button" className="c-btn c-btn--red c-btn--small" onClick={this.onClick}>See next week</button>
    }

    onClick() {
        window.dispatchEvent(new CustomEvent("whatson:load-more"));
    }
}



// WEBPACK FOOTER //
// ./src/whatson/components/LoadMoreNextWeek.js